import * as React from 'react';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import moment from 'moment';
import { convertDateToSelectedTimeZone } from 'src/utils/convertDateToSelectedTimeZone';

export const BasicDateCalendar = ({ handleChangeDate, value, futureDisable = false }: any) => {
  const currentDateTime = new Date();
  const convertToSelectTimeZon = new Date(convertDateToSelectedTimeZone(currentDateTime));
  const jsDate = moment(value, 'DD-MM-YYYY').toDate();
  return (
    <DateCalendar
      sx={{
        boxShadow: '0px 3px 14px 0px rgba(0, 0, 0, 0.08)',
        position: 'absolute',
        background: '#fff',
        zIndex: 10,
        marginTop: '43px',
        width: '280px',
        '& .css-6ipwqo-MuiButtonBase-root-MuiPickersDay-root:not(.Mui-selected)': {
          border: 'none !important',
        },
      }}
      defaultValue={jsDate}
      onChange={handleChangeDate}
      maxDate={convertToSelectTimeZon}
    />
  );
};
